/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-images';
import Slider from 'react-slick';
import { CloseLightbox } from '../InstagramSlider';
import useWindowSize from '../../hooks/useWindowSize';

function ImageShowcase({ images }) {
  const [showLightbox, setShowLightbox] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const { width } = useWindowSize();
  const isMobile = width <= 768;

  const settings = {
    dots: false,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      <div className="mls-images-container">
        {isMobile ? (
          <Slider {...settings}>
            {images.map((i, ind) => (
              <div
                key={ind}
                className="mobile-image-wrapper"
                role="button"
                onClick={() => {
                  setImageIndex(ind);
                  setShowLightbox(true);
                }}
              >
                <img
                  data-src={i}
                  alt=""
                  title=""
                  className="mls-image lazyload"
                />
              </div>
            ))}
          </Slider>
        ) : (
          images.map((i, ind) => (
            <div
              key={ind}
              role="button"
              className={`outer ${ind == 0 ? 'featured' : ''}`}
              onClick={() => {
                setImageIndex(ind);
                setShowLightbox(true);
              }}
            >
              <img
                data-src={i}
                alt=""
                title=""
                className="mls-image lazyload"
              />
            </div>
          ))
        )}
      </div>
      <Lightbox
        onClose={() => setShowLightbox(false)}
        onClickNext={() => setImageIndex(imageIndex + 1)}
        onClickPrev={() => setImageIndex(imageIndex - 1)}
        currentImage={imageIndex}
        isOpen={showLightbox}
        images={images.map(image => ({
          src: image,
        }))}
        onClickThumbnail={e => setImageIndex(e)}
        customControls={[
          <CloseLightbox onClick={() => setShowLightbox(false)} />,
        ]}
        closeButtonTitle="closeLightbox"
        leftArrowTitle="leftLightboxArrow"
        rightArrowTitle="rightLightboxArrow"
        showImageCount={false}
        showThumbnails
      />
    </>
  );
}

ImageShowcase.propTypes = {
  images: PropTypes.array.isRequired,
};

export default ImageShowcase;
